import { QuestionTypeInsert, QuestionTypeDelete, QuestionTypeUpdate, QuestionTypeGetById, QuestionTypeGetList, QuestionTypeGetPageList } from "@/api/questiontype/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    QuestionTypeInsert(context, payload) {
        return new Promise((resolve, reject) => {
            
            
            QuestionTypeInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    QuestionTypeUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            QuestionTypeUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    QuestionTypeGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            QuestionTypeGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    QuestionTypeGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            QuestionTypeGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    QuestionTypeGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            QuestionTypeGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}